import { TriggerButton, useDialog } from "widgets";

import { type ITableData } from "../../redux/modules/table-data.js";
import { VariantsRelatedGenomesDialog } from "../genome-viewer/variants-track/VariantsRelatedGenomesDialog.js";

interface IViewVariantGenomesButtonProps {
  table: ITableData;
  selectedIDs: number[];
}

export function ViewVariantGenomesButton(props: IViewVariantGenomesButtonProps) {
  const tooltipTextOfGroupRelated = "Display a list of genomes that contain the selected variants";
  const { dialogRef, dialogProps, underlayProps, state } = useDialog<HTMLDivElement>();

  const getDisabledTooltip = () => {
    return !props.selectedIDs.length
      ? "At least one row must be selected to display the list of related genomes."
      : null;
  };

  return (
    <>
      <TriggerButton
        icon={"genetics"}
        label={"View Genomes"}
        onPress={state.open}
        tooltip={tooltipTextOfGroupRelated}
        isDisabled={getDisabledTooltip()}
        showLabel
      />
      {state.isOpen && (
        <VariantsRelatedGenomesDialog
          closeFn={state.close}
          variantTable={props.table}
          selectedVariantIDs={props.selectedIDs}
          ref={dialogRef}
          dialogProps={dialogProps}
          underlayProps={underlayProps}
        />
      )}
    </>
  );
}
